import React from 'react';
import './SusuToggle.css';

/**
 * SusuToggle
 * A clean, perfectly aligned custom toggle switch designed to replace Semantic UI's `<Radio toggle />`.
 *
 * @param {boolean} checked - The current state of the toggle.
 * @param {function} onChange - Callback fired when the toggle is clicked. Passes the new boolean value.
 * @param {string} label - Text label to display next to the toggle.
 * @param {boolean} disabled - Whether the toggle is disabled.
 * @param {string} className - Optional additional CSS class names.
 */
const SusuToggle = ({ checked, onChange, label, disabled = false, className = '' }) => {
  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <div 
      className={`susu-toggle-wrapper ${disabled ? 'disabled' : ''} ${className}`} 
      onClick={handleToggle}
      role="switch"
      aria-checked={checked}
      tabIndex={disabled ? -1 : 0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleToggle();
        }
      }}
    >
      <div className={`susu-toggle-track ${checked ? 'checked' : ''}`}>
        <div className="susu-toggle-thumb" />
      </div>
      {label && <span className="susu-toggle-label">{label}</span>}
    </div>
  );
};

export default SusuToggle;
